import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface Currency {
  item: string;
}

export interface AffordabilityState {
  numberOfApplicants: number;
  buyerType: string;
  originalIncomePerson1: string;
  incomePerson1: number;
  currencyIncomePerson1: string;
  incomePerson2: number;
  originalIncomePerson2: string;
  currencyIncomePerson2: string;
  error?: any;
}

const initialState: AffordabilityState = {
  numberOfApplicants: 1,
  buyerType: '',
  incomePerson1: 0,
  originalIncomePerson1: '',
  originalIncomePerson2: '',
  currencyIncomePerson1: 'GBP',
  currencyIncomePerson2: 'GBP',
  incomePerson2: 0,
};

interface BuyerTypeData {
  buyerType: string;
  incomePerson1: number;
  incomePerson2?: number;
  originalIncomePerson1: string;
  originalIncomePerson2?: string;
  currencyIncomePerson1: string;
  currencyIncomePerson2?: string;
}

interface SetBuyerType {
  payload: BuyerTypeData;
}

interface SetApplicants {
  payload: number;
}

export const affordabilitySlice = createSlice({
  name: 'affordability',
  initialState,
  reducers: {
    setNumberOfApplicants: (state, action: SetApplicants) => {
      state.numberOfApplicants = action.payload;
      return state;
    },
    setBuyerTypeForOneApplicant: (state, action: SetBuyerType) => {
      state.buyerType = action.payload.buyerType;
      state.originalIncomePerson1 = action.payload.originalIncomePerson1;
      state.incomePerson1 = action.payload.incomePerson1;
      state.currencyIncomePerson1 = action.payload.currencyIncomePerson1;
    },
    setBuyerTypeForTwoApplicants: (state, action: SetBuyerType) => {
      state.buyerType = action.payload.buyerType;
      state.incomePerson1 = action.payload.incomePerson1;
      state.originalIncomePerson1 = action.payload.originalIncomePerson1;
      state.currencyIncomePerson1 = action.payload.currencyIncomePerson1;
      if (action.payload.incomePerson2) state.incomePerson2 = action.payload.incomePerson2;
      if (action.payload.originalIncomePerson2) state.originalIncomePerson2 = action.payload.originalIncomePerson2;
      if (action.payload.currencyIncomePerson2) state.currencyIncomePerson2 = action.payload.currencyIncomePerson2;
    },
    setError: (state, action) => {
      state.error = action.payload;
      return state;
    },
  },
});

export const { setNumberOfApplicants, setBuyerTypeForTwoApplicants, setBuyerTypeForOneApplicant, setError } =
  affordabilitySlice.actions;

export const selectAffordability = (state: RootState) => state.affordability;

export default affordabilitySlice.reducer;
